import React, { useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
import { primaryNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
import { ButtonLink } from '../ui/ButtonLink';
import { DesktopNavItem } from './DesktopNavItem';
import { MobileNavDrawer } from './MobileNavDrawer';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setDrawerOpen(false);
    setOpenMenu(null);
  }, [location.key]);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);
  return <>
      <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-200 ease-out ${scrolled ? 'border-b border-plum/10 bg-porcelain/95 backdrop-blur-md' : 'border-b border-transparent bg-transparent'}`} data-id="element-350" data-mp="6v5gvbexjz5m">
        <div className={`mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 transition-[height] duration-200 lg:px-10 ${scrolled ? 'h-16' : 'h-20'}`} data-id="element-351" data-mp="lkunhm5skvda">
          <Link to="/" aria-label="Aurevane Search Partners — home" className={scrolled ? '' : 'on-dark'} data-id="element-352" data-mp="3p1a23f0rrnum">
            <Logo tone={scrolled ? 'dark' : 'light'} data-id="element-353" data-mp="3u0mo5xjtgqw5" />
          </Link>
          <nav aria-label="Primary" className={`hidden xl:block ${scrolled ? '' : 'on-dark'}`} data-id="element-354" data-mp="3u2hbfiik8v3e">
            <ul className="flex items-center gap-0.5" data-id="element-355" data-mp="1uhejtl93vw3">
              {primaryNav.map(item => <DesktopNavItem key={item.label} item={item} solid={scrolled} open={openMenu === item.label} onOpenChange={open => setOpenMenu(open ? item.label : null)} data-id="element-356" data-mp="19c8e9noaoiw5" />)}
            </ul>
          </nav>
          <div className="flex items-center gap-2" data-id="element-357" data-mp="3jctbcclvmowv">
            <ButtonLink to="/employers#inquiry" size="sm" className="hidden sm:inline-flex" data-id="element-358" data-mp="3jcjkkmt0cdq4">
              Partner With Us
            </ButtonLink>
            <button type="button" onClick={() => setDrawerOpen(true)} aria-label="Open menu" aria-expanded={drawerOpen} className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-150 xl:hidden ${scrolled ? 'text-plum hover:bg-limestone' : 'on-dark text-porcelain hover:bg-porcelain/10'}`} data-id="element-359" data-mp="2qo4h8xj8njum">
              <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-360" data-mp="27wlf0sx1g9tn" />
            </button>
          </div>
        </div>
      </header>
      <MobileNavDrawer open={drawerOpen} onClose={closeDrawer} data-id="element-361" data-mp="22wqowrl37o9n" />
    </>;
}